var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSnooze(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4994 6.47309V6.00335C12.4994 3.42419 10.485 1.33337 8 1.33337C5.51504 1.33337 3.50058 3.42419 3.50058 6.00335V6.47309C3.50058 7.03681 3.33981 7.58792 3.03853 8.05697L2.30024 9.20639C1.62588 10.2563 2.1407 11.6833 3.31357 12.0153C6.38183 12.8838 9.61817 12.8838 12.6864 12.0153C13.8593 11.6833 14.3741 10.2563 13.6998 9.20639L12.9615 8.05697C12.6602 7.58792 12.4994 7.03681 12.4994 6.47309Z",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66666 6H9.33332L6.66666 8.66667H9.33332",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 12.6666C5.43668 13.8318 6.61497 14.6666 8 14.6666C9.38503 14.6666 10.5633 13.8318 11 12.6666",
    stroke: "currentColor",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnooze);
export default __webpack_public_path__ + "static/media/snooze.c908a21d5bc30d46658fec91686cedb2.svg";
export { ForwardRef as ReactComponent };